export const MAIN_LISTENER_ID = 'listener-id/main';
export const VIDEO_RENDER_LISTENER_ID = 'listener-id/video-render';
export const ESCAPE_KEYBOARD_LISTENER_ID =
    'keyboard-listener-id/escape-key-down';
export const SPACE_KEYBOARD_LISTENER_ID = 'keyboard-listener-id/space';
export const K_KEYBOARD_LISTENER_ID = 'keyboard-listener-id/k';

export const messageListenerIds = [
    MAIN_LISTENER_ID,
    VIDEO_RENDER_LISTENER_ID,
] as const;

export const keyDownListenerIds = [
    ESCAPE_KEYBOARD_LISTENER_ID,
    SPACE_KEYBOARD_LISTENER_ID,
    K_KEYBOARD_LISTENER_ID,
] as const;

export type MessageListenerId = (typeof messageListenerIds)[number];

export type KeyDownListenerId = (typeof keyDownListenerIds)[number];

// Sent from parent page to the iframe as initialize signal
//   Passes "PageMetadata" as a payload
export const FRAME_INIT_MESSAGE_TYPE = 'REELFLOW_FRAME_INIT';
// Sent from parent page to the iframe when initialization data (metadata) changes
//   Passes "PageMetadata" as a payload
export const METADATA_CHANGE_MESSAGE_TYPE = 'REELFLOW_METADATA_CHANGE';
// [OVERLAY ONLY] Sent from parent page to the iframe when initialization data (metadata) changes
//   Doesn't have any payload options
export const PLAYER_OPEN_MESSAGE_TYPE = 'REELFLOW_PLAYER_OPEN';
// [OVERLAY ONLY] Sent from parent page to the iframe when user is requesting to close the player (through public JS API)
export const PLAYER_CLOSE_REQUEST_MESSAGE_TYPE =
    'REELFLOW_PLAYER_CLOSE_REQUEST';
// [OVERLAY ONLY] Sent from iframe to parent page when user clicks close button
//   Doesn't have any payload options
export const PLAYER_CLOSE_MESSAGE_TYPE = 'REELFLOW_PLAYER_CLOSE';
// [INLINE ONLY]
export const PLAYER_INTERSECTION_CHANGE_MESSAGE_TYPE =
    'REELFLOW_PLAYER_INTERSECTION_CHANGE';
// Sent from iframe to parent page when user clicks anchor link
//   Passes "PageScrollMessagePayload" as a payload
export const PAGE_SCROLL_REQUEST_MESSAGE_TYPE = 'REELFLOW_PAGE_SCROLL_REQUEST';
// Sent from iframe to parent page when user clicks on action button
//   Passes "ActionButtonClickPayload" as a payload
export const ACTION_BUTTON_CLICK_MESSAGE_TYPE = 'REELFLOW_ACTION_BUTTON_CLICK';

export const messageList = [
    FRAME_INIT_MESSAGE_TYPE,
    METADATA_CHANGE_MESSAGE_TYPE,
    PLAYER_OPEN_MESSAGE_TYPE,
    PLAYER_CLOSE_REQUEST_MESSAGE_TYPE,
    PLAYER_CLOSE_MESSAGE_TYPE,
    PLAYER_INTERSECTION_CHANGE_MESSAGE_TYPE,
    PAGE_SCROLL_REQUEST_MESSAGE_TYPE,
    ACTION_BUTTON_CLICK_MESSAGE_TYPE,
] as const;

export type MessageType = (typeof messageList)[number];

export type Message<T = Record<string, string | number | boolean>> = {
    type: MessageType;
    data: T;
};

export type PlayerIntersectionChangeMessagePayload = {
    isIntersecting: boolean;
};

export type PageScrollMessagePayload = {
    elementId: string;
    scrollStateDelay?: number;
    scrollBehavior?: 'smooth' | 'instant';
    scrollBlock?: 'start' | 'center' | 'end';
    scrollInline?: 'start' | 'center' | 'end';
};

export type ActionButtonClickPayload = {
    id: string;
    label: string;
    index: number;
};
